import React, { useState } from "react";
import RoutesFile from "./RoutesFile";
import Navbar from "./components/Navbar";  // ✅ Correct path

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

// Web3Modal Configuration
import { createWeb3Modal, defaultConfig } from "@web3modal/ethers/react";

const projectId = "45a0e6f0ec40c32ea865faa6d7000f5e";
const bscMainNet = {
  chainId: 56,
  name: "BSC Mainnet",
  currency: "BNB",
  explorerUrl: "https://bscscan.com/",
  rpcUrl: "https://bsc-mainnet.infura.io/v3/0128d6f4a7974e9c931c76b7dd439f87",
};
const metadata = {
  name: "My Website",
  description: "My Website description",
  url: "https://mywebsite.com",
  icons: ["https://avatars.mywebsite.com/"],
};

const ethersConfig = defaultConfig({ metadata });
createWeb3Modal({
  ethersConfig,
  chains: [bscMainNet],
  projectId,
  enableAnalytics: true,
});

function App() {
  const [activeSection, setActiveSection] = useState("home");  // Add state here

  return (
    <>
      <Navbar setActiveSection={setActiveSection} />  {/* Pass setActiveSection */}
      <RoutesFile activeSection={activeSection} />   {/* Pass activeSection */}
      <ToastContainer />
    </>
  );
}

export default App;
